// extracted by mini-css-extract-plugin
export var actions = "_ry-4";
export var item = "_ry-1";
export var price = "_ry-3";
export var quantity = "_ry-2";
export var table = "_ry-0";